module.exports = __webpack_public_path__ + "assets/img/doc.44a9c453.svg";